import { faDownload } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UnstyledAnchor } from 'components/unstyled-link';
import { BundledTicket, Ticket } from 'types/domain';

interface TicketItemDownloadButtonProps {
    item: Ticket | BundledTicket;
}

const TicketItemDownloadButton = (props: TicketItemDownloadButtonProps) => {
    const { item } = props;

    const handleClick = () => {
        if (item.pdf) {
            window.open(item.pdf, '_blank', 'noopener,noreferrer');
        }
    };

    return (
        <UnstyledAnchor
            href={item.pdf ?? '#'}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="download ticket"
            className={`inline-flex h-8 items-center gap-2 rounded-md border bg-white px-2 text-sm font-medium text-black text-gray-600 ${
                !item.pdf ? 'cursor-not-allowed opacity-50' : 'hover:bg-gray-200'
            }`}
            onClick={handleClick}
        >
            {'campaign_bundle_id' in item && <span>Download All</span>}
            <FontAwesomeIcon icon={faDownload} />
        </UnstyledAnchor>
    );
};

export { TicketItemDownloadButton };
